import * as types from "../types/index";
import { core } from "./core";

export const getRules = () => {
  return core.API2(
    "GET",
    `/v2/rules`,
    types.GET_RULES,
    types.GET_RULES_SUCCESS,
    types.GET_RULES_FAILURE
  );
};

export const createHourTypeRule = (data) => {
  return core.API(
    "POST",
    `/rules/hour-type-rule`,
    types.CREATE_RULE,
    types.CREATE_RULE_SUCCESS,
    types.CREATE_RULE_FAILURE,
    data
  );
};

export const createAddonTypeRule = (data) => {
  return core.API(
    "POST",
    `/addon/addon-type-rule`,
    types.CREATE_RULE,
    types.CREATE_RULE_SUCCESS,
    types.CREATE_RULE_FAILURE,
    data
  );
};

export const updateHourTypeRule = (id, data) => {
  return core.API(
    "PUT",
    `/rules/hour-type-rule/${id}`,
    types.UPDATE_RULE,
    types.UPDATE_RULE_SUCCESS,
    types.UPDATE_RULE_FAILURE,
    data
  );
};

export const updateAddonTypeRule = (id, data) => {
  return core.API(
    "PUT",
    `/addon/addon-type-rule/${id}`,
    types.UPDATE_RULE,
    types.UPDATE_RULE_SUCCESS,
    types.UPDATE_RULE_FAILURE,
    data
  );
};

export const deleteHourTypeRule = (id, data) => {
  return core.API(
    "DELETE",
    `/rules/hour-type-rule/${id}`,
    types.DELETE_RULE,
    types.DELETE_RULE_SUCCESS,
    types.DELETE_RULE_FAILURE,
    data
  );
};

export const deleteAddonTypeRule = (id, data) => {
  return core.API(
    "DELETE",
    `/addon/addon-type-rule/${id}`,
    types.DELETE_RULE,
    types.DELETE_RULE_SUCCESS,
    types.DELETE_RULE_FAILURE,
    data
  );
};

// onboarding: simplified rule
export const createSimplifiedRule = (data) => {
  return core.API(
    "POST",
    `/onboarding/add-interval`,
    types.CREATE_SIMPLIFIED_RULE,
    types.CREATE_SIMPLIFIED_RULE_SUCCESS,
    types.CREATE_SIMPLIFIED_RULE_FAILURE,
    data
  );
};
